/**
 * Google Ads Conversion Tracking Utility
 * Tag ID: AW-17968572298
 * Conversion Label: G3AoCPem3PwbEIrPivhC
 */

const CONVERSION_ID = 'AW-17968572298';
const CONVERSION_LABEL = 'G3AoCPem3PwbEIrPivhC';
const SEND_TO = `${CONVERSION_ID}/${CONVERSION_LABEL}`;

// Track a general conversion event
export const trackConversion = (value = null) => {
  if (typeof window !== 'undefined' && window.gtag) {
    const conversionData = {
      'send_to': SEND_TO,
    };
    
    if (value) {
      conversionData['value'] = value;
      conversionData['currency'] = 'CAD';
    }
    
    window.gtag('event', 'conversion', conversionData);
    console.log('Google Ads conversion tracked');
  }
};

// Track lead form submission (Contact, Seller forms)
export const trackLeadSubmission = (formType = 'contact') => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Fire the conversion event with the specific label
    window.gtag('event', 'conversion', {
      'send_to': SEND_TO,
    });
    
    // Also track as a custom event for reporting
    window.gtag('event', 'lead_submission', {
      'event_category': 'Lead',
      'event_label': formType,
      'form_type': formType,
    });
    
    console.log('Lead submission conversion tracked:', formType);
  }
};

// Track user registration
export const trackRegistration = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Fire the conversion event
    window.gtag('event', 'conversion', {
      'send_to': SEND_TO,
    });
    
    window.gtag('event', 'sign_up', {
      'method': 'email',
    });
    
    console.log('Registration conversion tracked');
  }
};

// Track property inquiry
export const trackPropertyInquiry = (propertyId, propertyPrice) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Fire the conversion event
    window.gtag('event', 'conversion', {
      'send_to': SEND_TO,
      'value': propertyPrice,
      'currency': 'CAD',
    });
    
    window.gtag('event', 'generate_lead', {
      'event_category': 'Property',
      'event_label': propertyId,
      'value': propertyPrice,
      'currency': 'CAD',
    });
    
    console.log('Property inquiry conversion tracked:', propertyId);
  }
};

// Track page view (for SPA navigation)
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      'page_path': pagePath,
      'page_title': pageTitle,
    });
  }
};

export default {
  trackConversion,
  trackLeadSubmission,
  trackRegistration,
  trackPropertyInquiry,
  trackPageView,
};
